import { api } from '../../services/api'

const state = () => ({
  items: [],
  current: null,
  loading: false,
  error: null
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) {
    console.log('🟢 SET_ITEMS:', items)
    state.items = items
  },
  SET_CURRENT(state, item) {
    console.log('🟢 SET_CURRENT:', item)
    state.current = item
  },
  ADD_ITEM(state, item) {
    console.log('🟢 ADD_ITEM:', item)
    state.items.unshift(item)
  },
  UPDATE_ITEM(state, item) {
    console.log('🟢 UPDATE_ITEM:', item)
    const i = state.items.findIndex((x) => String(x.id) === String(item.id))
    console.log('Index found:', i)
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) {
    console.log('🟢 REMOVE_ITEM:', id)
    state.items = state.items.filter((x) => String(x.id) !== String(id))
  },
  SET_LOADING(state, v) {
    console.log('🟡 LOADING:', v)
    state.loading = v
  },
  SET_ERROR(state, e) {
    console.log('🔴 ERROR:', e)
    state.error = e
  }
}

const actions = {
  async list({ commit }) {
    console.log('➡️ ACTION: list() started')
    commit('SET_LOADING', true)

    try {
      const { data } = await api.get('admin/expenses')
      console.log('✅ API RESPONSE (list):', data)

      const items = Array.isArray(data) ? data : data?.items || []
      console.log('📦 Parsed items:', items)

      commit('SET_ITEMS', items)
      commit('SET_ERROR', null)
    } catch (e) {
      console.error('❌ list() error:', e)
      commit('SET_ERROR', e.message || 'Failed to load expenses')
    } finally {
      commit('SET_LOADING', false)
      console.log('⬅️ ACTION: list() finished')
    }
  },

  async fetchOne({ commit }, id) {
    console.log('➡️ ACTION: fetchOne()', id)

    try {
      const { data } = await api.get(`admin/expenses/${id}`)
      console.log('✅ API RESPONSE (fetchOne):', data)

      commit('SET_CURRENT', data)
      return data
    } catch (e) {
      console.error('❌ fetchOne() error:', e)
    }
  },

  async create({ commit }, payload) {
    console.log('➡️ ACTION: create()', payload)

    try {
      const { data } = await api.post('admin/expenses', payload)
      console.log('✅ API RESPONSE (create):', data)

      commit('ADD_ITEM', data)
      return data
    } catch (e) {
      console.error('❌ create() error:', e)
    }
  },

  async update({ commit }, { id, payload }) {
    console.log('➡️ ACTION: update()', id, payload)

    try {
      const { data } = await api.put(`admin/expenses/${id}`, payload)
      console.log('✅ API RESPONSE (update):', data)

      commit('UPDATE_ITEM', data)
      return data
    } catch (e) {
      console.error('❌ update() error:', e)
    }
  },

  async remove({ commit }, id) {
    console.log('➡️ ACTION: remove()', id)

    try {
      await api.delete(`admin/expenses/${id}`)
      console.log('✅ Deleted ID:', id)

      commit('REMOVE_ITEM', id)
    } catch (e) {
      console.error('❌ remove() error:', e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}